<template>
  <div class="flex flex-wrap gap-3 relative w-full">
    <div class="flex gap-2">
      <Checkbox
        :modelValue="modelValue"
        :binary="true"
        :name="props.name"
        :input-id="props.label"
        class="tv__checkbox"
        @change="handleChange"
      />
      <div class="flex flex-column gap-1">
        <label :for="props.label" class="tv__checkbox-label inline-block">
          {{ props.label }}
        </label>
        <span class="input-message-content">
          <small
            v-if="props.customErrorMessage"
            class="tv__input-error-message flex"
          >
            <i class="tv__input-icon tv__input-icon-error" />
            {{ props.customErrorMessage }}
          </small>
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";
import Checkbox from "primevue/checkbox";

const props = defineProps({
  label: String,
  customErrorMessage: String,
  error: Boolean,
  name: String,
  modelValue: [Boolean, String],
});

const emit = defineEmits(["update:modelValue"]);

const handleChange = (event) => {
  emit("update:modelValue", event.target.checked);
};
</script>
